// https://www.w3.org/TR/navigation-timing-2/#processing-model

/**
 * We're going to report navigation costs as part of optimizely's implementation as Optimizely Web relies on redirects
 * to allow experimentation. In lab, Optimizely Web adds about 500ms to page load time.
 */
function navigationPerformanceHelper() {
  if (!window?.performance || !window?.location || !window?.sessionStorage) {
    return;
  }

  const performanceEntry = window.performance.getEntriesByName(window.location.href);
  let currentTiming = 0;
  let navigated = false;

  if (performanceEntry.length >= 1) {
    navigated = performanceEntry[0]?.type === 'navigate';
    window.sessionStorage.setItem(
      window.location.href,
      JSON.stringify({
        href: window.location.href,
        time: performanceEntry[0],
      })
    );
    currentTiming = performanceEntry[0].responseEnd;
    window.sessionStorage.setItem(window.optimizelyConfigFS.navigation_time, currentTiming);
  }

  // If we've done a recent redirect, be sure to track it
  if (navigated && document?.referrer && document.referrer !== '') {
    let redirectedPageNavigation = window.sessionStorage.getItem(document.referrer);
    if (redirectedPageNavigation != null) {
      redirectedPageNavigation = JSON.parse(redirectedPageNavigation);
      currentTiming += redirectedPageNavigation.time.responseEnd;
      window.sessionStorage.setItem(window.optimizelyConfigFS.navigation_time, currentTiming);
    }
  }
}

navigationPerformanceHelper();
